export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9574.4c0e1d32.jpg";